import React, { useEffect, useState } from "react";
import {
    IncompleteProfileTile,
    ItemsInCartTile,
    TotalOrderPlaceTiles,
    TotalInvoiceTile,
    DiamondRequestTile,
    DashboardSearchTab,
    DashboardTracklist,
    RecentDiamondTile,
    SavedSearchtile,
    SalesExecutiveTile,
} from "../widgets";
import { Alert, Button, Modal } from "react-bootstrap";
import { FaInfoCircle } from "react-icons/fa";
import { toAbsoluteUrl } from "../../_helpers";
import SVG from "react-inlinesvg";
// import { GetCookies } from "../../_helpers/Cookies";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import { NODE_API_URL,BASE_URL } from "../../../env_config";
import DashboardSkeleton from "./DashboardSkeleton"
import Cookies from "js-cookie"

export const Dashboard = ({
    conversionrate,
    symbol,
    language,
    isprofilecomplete,
    userinfo,
}) => {
    const userData = React.useMemo(() => localStorage.getItem("userData"), []);
    const user = JSON.parse(userData);
    // console.log("userinfo",userinfo)
    const [dashData, setDashData] = React.useState([]);
    const [salesData, setSalesData] = React.useState([]);
    const [convinienceFee, setConvinienceFee] = React.useState([]);
    const [kycMessage,setKycMessage] = useState("")
    const [kycAlert,setAlert] = useState("")

    useEffect(() => {
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/getKycMessage`,
            headers: { 
                "Content-Type": "application/json",
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
            }
        }).then((res) => {
            if (res && res?.data  && res?.data?.kycmessage && res?.data?.kycmessage?.kyc_status) {
                if(res?.data?.kycmessage?.message){
                    if(res?.data?.kycmessage?.kyc_status === "KYC_REJ"){
                        setAlert("danger")
                        setKycMessage(res?.data?.kycmessage?.message + ` ● Reason:${res?.data?.kycmessage?.reject_reason}`)
                    }
                    else if(res?.data?.kycmessage?.kyc_status === "NO_KYC"){
                        setAlert("danger")
                        setKycMessage(res?.data?.kycmessage?.message)
                    }
                    else{
                        setAlert("warning")
                        setKycMessage(res?.data?.kycmessage?.message)
                    }
                }
            }
        }).
        catch(error => {
          if(error?.response?.data?.message === "UnAuthorized!"){
            var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if(cookies[i] && !cookies[i].includes("view")){
              var equals = cookies[i].indexOf("=");
              var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
          }
          
          window.location.replace(`${BASE_URL}/logout`);
        }
        })
    },[])
    useEffect(() => {
        let isMounted = true;
        const userCountry = {
            country: `${userinfo.country}`,
        };
        axios({
            method: "GET",
            url: `${NODE_API_URL}/INTL/fetchDashboardData`,
            headers: { 
                "Content-Type": "application/json",
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
             }
        }).then((res) => {
            if (res && res.data && res.data.data) {
                setDashData(res.data.data);
                setSalesData(res.data.data.salesExecutive);
                // console.log("data", res);
            }
        }).
        catch(error => {
          if(error?.response?.data?.message === "UnAuthorized!"){
            var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if(cookies[i] && !cookies[i].includes("view")){
              var equals = cookies[i].indexOf("=");
              var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
          }
          
          window.location.replace(`${BASE_URL}/logout`);
        }
        })
        axios({
            method: "GET",
            url: `${NODE_API_URL}/INTL/get-conviniencefee`,
            headers: { 
                "Content-Type": "application/json",
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
            },
            params: userCountry,
        }).then((res) => {
            if (res && res.data) {
                setConvinienceFee(res.data.data);
                // console.log("data", res);
            }
        }).
        catch(error => {
          if(error?.response?.data?.message === "UnAuthorized!"){
            var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if(cookies[i] && !cookies[i].includes("view")){
              var equals = cookies[i].indexOf("=");
              var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
          }
          
          window.location.replace(`${BASE_URL}/logout`);
        }
        })
        return () => {
            isMounted = false;
        };
    }, [user.CustomerId,userinfo.country]);
    // console.log(userinfo.kyc_status,"STATSYYSS")
    return (
        <> {userinfo.id ?
            <>
                
                <div className="row m-0 mb-3 rounded p-4 shadow-sm bg-white">
                    <div className="col-12 justify-content-md-between d-flex align-items-center">
                        <h1 className="text-capitalize text-primary mb-0">
                            Welcome {userinfo ? userinfo.cname : ""}{" "}
                            <SVG
                                src={toAbsoluteUrl("/media/General/ic_fest.svg")}
                            />
                        </h1>
                        <span className="font-size-lg font-weight-bold">
                            Convenience Fee
                            <OverlayTrigger
                                placement="bottom"
                                className="text-capitalize"
                                overlay={
                                    <Tooltip id="tooltip">
                                        {convinienceFee.ups_charges?<div>UPS ${convinienceFee.ups_charges}</div>:""}
                                        {convinienceFee.fedex_charges?<div>FedEx ${convinienceFee.fedex_charges}</div>:""}
                                        {userinfo.country === "Hong Kong"?<div>Hk Delivery $0</div>:""}
                                    </Tooltip>
                                }
                            >
                                <FaInfoCircle className="text-hover-warning ml-2 cursor-pointer" />
                            </OverlayTrigger>
                        </span>
                    </div>
                    {kycMessage ?
                        <div className="col-12 mt-2">
                            <Alert variant={kycAlert}>
                            {kycMessage}
                            </Alert>
                        </div>
                    : null}
                </div>
                <div className="row">
                    {userinfo.kyc_status === "NO_KYC" ? (
                        <div className="col-md-4">
                            <div className="row">
                                <div className="col-12">
                                    <IncompleteProfileTile />
                                </div>
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
    
                    <div
                        className={`${
                            userinfo.kyc_status === "NO_KYC"
                                ? "col-md-8 profileIncompleteDashboard"
                                : "col-md-12 profileIncompleteDashboard"
                        }`}
                    >
                        <div className="row">
                            <div className="col-lg-3 col-md-6">
                                <ItemsInCartTile
                                    holdCount={
                                        dashData && dashData.totalHoldOrders
                                    }
                                    language={language}
                                />
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <TotalOrderPlaceTiles
                                    totalOrderCount={
                                        dashData && dashData.totalOrders
                                    }
                                    language={language}
                                />
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <TotalInvoiceTile
                                    totalInvoiceCount={
                                        dashData && dashData.totalInvoices
                                    }
                                    language={language}
                                />
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <DiamondRequestTile language={language} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <DashboardSearchTab language={language} />
                    </div>
                    <div className="col-md-6">
                        <DashboardTracklist
                            language={language}
                            symbol={symbol}
                            conversionrate={conversionrate}
                            itemInWishList={dashData && dashData.itemInWishList}
                            userinfo={userinfo}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-8">
                        <RecentDiamondTile
                            language={language}
                            symbol={symbol}
                            conversionrate={conversionrate}
                            userinfo={userinfo}
                        />
                    </div>
                    <div className="col-md-4">
                        <div className="row">
                            <div className="col-12">
                                <SavedSearchtile language={language} />
                            </div>
                            <div className="col-12">
                                <SalesExecutiveTile
                                    language={language}
                                    salesData={salesData && salesData}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </> : <DashboardSkeleton /> }
        </> 
    );
};
